import React, { useState } from "react";
import { PurchaseData } from "../../api/mockData";
import { PurchasedItem } from "../PurchasedItem";
import { Accordion } from "../Accordion";
import { PurchasedModal } from "../PurchasedModal";
import { Section } from "../Section";
import { NeedField, SmallDescription } from "./elements";

export interface Props {}
export interface Spec {
  gb: string;
  noScratches: string;
  someScratches: string;
  noticeableScratches: string;
  crackedScreen: string;
}

export const PurchasedList: React.FC = React.memo(() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedName, setSelectedName] = useState("");

  const [selectedSpec, setSelectedSpec] = useState<Spec | undefined>({
    gb: "",
    noScratches: "",
    someScratches: "",
    noticeableScratches: "",
    crackedScreen: "",
  });

  return (
    <Section title="買取商品一覧">
      <NeedField>
        <label>web申し込みの手順</label>
        <SmallDescription>
          1. お売りいただく端末を以下から選択。
        </SmallDescription>
        <SmallDescription>
          2. 端末のメモリを選択し対象状態の申込ボタンを押す。
        </SmallDescription>
        <SmallDescription>
          3. 申込ページにて全ての項目を入力後、送信して完了。
        </SmallDescription>
      </NeedField>

      {PurchaseData.map((item, index) => {
        return (
          <Accordion
            isSmall={false}
            key={`accordion-item${index}`}
            title={item.series}
          >
            <PurchasedItem
              model={item.model}
              setSelectedName={setSelectedName}
              setSelectedSpec={setSelectedSpec}
              setIsModalOpen={setIsModalOpen}
            />
          </Accordion>
        );
      })}
      {isModalOpen && (
        <PurchasedModal
          selectedName={selectedName}
          selectSpec={selectedSpec}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </Section>
  );
});

PurchasedList.displayName = "PurchasedList";
